import React from "react";
import LabelContent from "./LabelContent";

/**
 * Affiche une étiquette à l'échelle écran, dans un cadre pointillé matérialisant
 * la taille physique réelle. `scale` agrandit visuellement l'aperçu (via `zoom`)
 * sans changer les dimensions logiques (le contenu reste défini en mm).
 */
const LabelPreview = ({type, item, format, selectedFields, scale = 1.7}) => (
    <div
        style={{zoom: scale}}
        className="inline-block border border-dashed border-gray-400 dark:border-gray-500 bg-white shadow-sm rounded-sm overflow-hidden"
    >
        <LabelContent type={type} item={item} format={format} selectedFields={selectedFields}/>
    </div>
);

export default LabelPreview;
